import { Popover, PopoverContent, PopoverTrigger } from '@/components';
import {
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import {
  faCircleQuestion,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type InfoPopoverProps = {
  text: string;
  icon?: IconDefinition;
  iconAriaLabel?: string;
  className?: string;
};

export function InfoPopover({
  text,
  icon,
  iconAriaLabel,
  className,
}: InfoPopoverProps) {
  return (
    <>
      <Tooltip>
        <TooltipTrigger
          aria-label={iconAriaLabel ?? 'Info'}
          className={cn(className, 'md:inline-flex hidden')}
          asChild>
          <span onClick={(e) => e.preventDefault()}>
            <FontAwesomeIcon
              icon={icon ?? faCircleQuestion}
              className="text-primary-blue-500"
            />
          </span>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent className="min-w-30 max-w-85 w-82.5">
            <span className="wrap-normal text-neutrals-900 text-sm font-normal leading-5">
              {text}
            </span>
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
      <Popover>
        <PopoverTrigger
          aria-label={iconAriaLabel ?? 'Info'}
          className={cn(className, 'inline-flex md:hidden')}>
          <FontAwesomeIcon
            icon={icon ?? faCircleQuestion}
            className="text-primary-blue-500"
          />
        </PopoverTrigger>
        <PopoverContent className="min-w-30 max-w-85 w-82.5">
          <span className="wrap-normal text-neutrals-900 text-sm font-normal leading-5">
            {text}
          </span>
        </PopoverContent>
      </Popover>
    </>
  );
}
